// web fallback: disable the date/time picker modal entirely
// this avoids bundling the native datetimepicker package on web

export type PickerMode = 'date' | 'time' | null;

interface Props {
  visible: boolean;
  mode: PickerMode;
  initialValue: Date | null;
  selectedDate?: Date | null;
  onCancel: () => void;
  onSave: (selected: Date) => void;
}

export function DateTimePickerModal(_props: Props) {
  return null;
}

export default DateTimePickerModal;
